import axios from 'axios';

function getApiBaseUrl(): string {
  // Android emulator needs 10.0.2.2 to reach host machine
  if ((window as any)?.Capacitor?.getPlatform?.() === 'android') {
    return 'http://10.0.2.2:3000/api';
  }

  // Web / everything else
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';
}

export const baseAPIURL = getApiBaseUrl();

const api = axios.create({
  baseURL: baseAPIURL,
  withCredentials: true,
});

export default api;
